<ng-template #signEulaConfirmFooter>
    <n-checkbox id="sign_eula_confirm_checkbox"
        [label]="i18n.signEulaConfirmCheckbox"
        [(ngModel)]="isSignedEula">
    </n-checkbox>
    <div class="sign-eula-bottom-btns">
        <button id="sign_eula_info_prompt_ok_btn"
            nButton
            theme="primary"
            [disabled]="!isSignedEula"
            (click)="signEulaConfirmOk()"
            [label]="i18n.okBtn">
        </button>
        <button id="sign_eula_info_prompt_cancel_btn"
            nButton
            (click)="signEulaConfirmCancel()"
            [label]="i18n.cancelBtn">
        </button>
    </div>
</ng-template>